"use strict";

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestPlugin = requestPlugin;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _reduxActions = require("redux-actions");

var _constants = require("../constants");

var _language = require("../utilities/language");

var _converters = require("../utilities/converters");

var _mutators = require("../utilities/mutators");

var _introspection = require("../utilities/introspection");

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

var initialState = {};
var initialResourceMetadata = {
  createStatus: _constants.readyState.IDLE,
  readStatus: _constants.readyState.IDLE,
  updateStatus: _constants.readyState.IDLE,
  deleteStatus: _constants.readyState.IDLE
}; // eslint-disable-next-line import/prefer-default-export

function requestPlugin(resourceType, options) {
  return (0, _reduxActions.handleActions)((0, _defineProperty2.default)({}, (0, _reduxActions.combineActions)(_constants.actionTypes.REQUEST_PENDING, _constants.actionTypes.REQUEST_REJECTED, _constants.actionTypes.REQUEST_FULFILLED, _constants.actionTypes.REQUEST_IDLE), function (previousState, action) {
    if (!(0, _introspection.isResourceType)(action, resourceType)) {
      return previousState;
    }

    var idAttribute = options.idAttribute;
    var previousLists = previousState.lists,
        previousMetadata = previousState.metadata,
        previousRequests = previousState.requests,
        previousResources = previousState.resources;
    var list = (0, _introspection.getListName)(action);
    var operationType = (0, _introspection.getOperationType)(action);
    var requestKey = (0, _introspection.getRequestKey)(action);
    var resources = (0, _introspection.getResourcesArray)(action, {
      silent: !(0, _introspection.isFulfilledAction)(action)
    });
    var nextLists = previousLists;
    var nextMetadata = previousMetadata;
    var nextRequests = previousRequests;
    var nextResources = previousResources;

    if (!(0, _language.isNil)(resources)) {
      if ((0, _introspection.isDeleteRequestAction)(action)) {
        // Only delete resources when request is fulfilled.
        if ((0, _introspection.isFulfilledAction)(action)) {
          nextResources = (0, _mutators.deleteResources)({
            previousResources: previousResources,
            resources: resources,
            idAttribute: idAttribute
          });
        }
      } else {
        nextResources = (0, _mutators.upsertResources)({
          previousResources: previousResources,
          resources: resources,
          idAttribute: idAttribute,
          mergeResources: (0, _introspection.getMergeResources)(action, resourceType)
        });

        if ((0, _introspection.isFulfilledAction)(action) && !(0, _language.isNil)(list)) {
          nextLists = (0, _mutators.upsertList)({
            previousLists: previousLists,
            resources: resources,
            idAttribute: idAttribute,
            listName: list,
            mergeLists: (0, _introspection.getMergeLists)(action, resourceType)
          });
        }
      }

      nextMetadata = (0, _mutators.upsertResourceMetadata)({
        previousMetadata: previousMetadata,
        idAttribute: idAttribute,
        resources: resources,
        metadata: (0, _defineProperty2.default)({}, (0, _converters.statusKeyFromAction)(action), (0, _converters.requestStatusFromAction)(action)),
        initialResourceMetadata: initialResourceMetadata,
        mergeMetadata: (0, _introspection.getMergeMetadata)(action, resourceType)
      });
    }

    if (!(0, _language.isNil)(requestKey)) {
      nextRequests = (0, _mutators.upsertRequest)({
        idAttribute: idAttribute,
        previousRequests: previousRequests,
        operationType: operationType,
        requestName: (0, _introspection.getRequestName)(action),
        requestKey: requestKey,
        requestStatus: (0, _converters.requestStatusFromAction)(action),
        requestProperties: (0, _introspection.getRequestProperties)(action),
        resourceType: resourceType,
        resources: resources || (0, _language.getProperty)(previousRequests, [requestKey, 'resources'])
      });
    }

    return _objectSpread(_objectSpread({}, previousState), {}, {
      lists: nextLists,
      metadata: nextMetadata,
      requests: nextRequests,
      resources: nextResources
    });
  }), initialState);
}